import router from '.';

let nextState = {};
let prevState = {};

const foo = (dispatch) => {};

const subscribe = ({ getState, dispatch }) => {
  nextState = getState();

  foo(dispatch);

  prevState = nextState;
};

export default {
  subscribe,
};
